enum SubscriptionStatus {
  Active = 'Active',
  Expired = 'Closed',
  Pending = 'Pending',
  Terminated = 'Terminated',
  DoNotRenew = 'DoNotRenew',
  Suspended = 'Suspended',
  Canceled = 'Canceled',
  NonMember = 'None',
  Unknown = 'Unknown',
}
export default SubscriptionStatus;
